import type { ThemeTypes } from '@common/types/theme/ThemeType';
import {ULAVAL_RED_THEME} from "./LightTheme";

const ULAVAL_DARK_RED_THEME: ThemeTypes = {
    name: 'DARK_RED_THEME',
    dark: true,
    variables: {
        'border-color': '#3D3D3D'
    },
    colors: {
        important: '#E30513',
        primary: '#F2828A',
        secondary: '#FFC103',
        info: '#41B2FF',
        success: '#51A27E',
        accent: '#F7A941',
        warning: '#FFE081',
        error: '#E30513',

        lightprimary: '#7A1A23',
        lightsecondary: '#806101',
        lightsuccess: '#29513F',
        lighterror: '#720209',
        lightwarning: '#7D5520',
        lightinfo: '#004D80',

        textPrimary: '#F5F5F5',
        textSecondary: '#FFFFFF',
        borderColor: '#3D3D3D',
        inputBorder: '#515151',
        containerBg: '#1C1C1C',
        background: '#121212',
        hoverColor: '#2A2A2A',
        surface: '#202020',
        'on-surface-variant': '#DCDCDC',

        grey100: '#282828',
        grey200: '#3D3D3D',

        buttonHover: '#7A1A23',
        buttonHoverText: '#FCE5E7',
        buttonSecondaryHover: '#F2828A',
        buttonSecondaryHoverText: '#282828',

        navActiveText: '#FFFFFF',
        navHoverText: '#F2828A',

        surfaceTooltip: '#F5F5F5',
        onSurfaceTooltip: '#282828'
    }
};

const ULAVAL_DARK_BLUE_THEME: ThemeTypes = {
    name: 'DARK_BLUE_THEME',
    dark: true,
    variables: {
        'border-color': '#3D3D3D'
    },
    colors: {
        important: '#E30513',
        primary: '#41B2FF',
        secondary: '#FFE081',
        info: '#80CFF2',
        success: '#51A27E',
        accent: '#BD809E',
        warning: '#F7A941',
        error: '#E30513',

        lightprimary: '#004D80',
        lightsecondary: '#806101',
        lightsuccess: '#29513F',
        lighterror: '#720209',
        lightwarning: '#7D5520',
        lightinfo: '#004D80',

        textPrimary: '#F5F5F5',
        textSecondary: '#FFFFFF',
        borderColor: '#3D3D3D',
        inputBorder: '#515151',
        containerBg: '#1C1C1C',
        background: '#121212',
        hoverColor: '#2A2A2A',
        surface: '#202020',
        'on-surface-variant': '#DCDCDC',

        grey100: '#282828',
        grey200: '#3D3D3D',

        buttonHover: '#004D80',
        buttonHoverText: '#E5F5FF',
        buttonSecondaryHover: '#41B2FF',
        buttonSecondaryHoverText: '#282828',

        navActiveText: '#FFFFFF',
        navHoverText: '#80CFF2',

        surfaceTooltip: '#F5F5F5',
        onSurfaceTooltip: '#282828'
    }
};

const ULAVAL_DARK_PURPLE_THEME: ThemeTypes = {
    name: 'DARK_PURPLE_THEME',
    dark: true,
    variables: {
        'border-color': '#3D3D3D'
    },
    colors: {
        important: '#E30513',
        primary: '#B896BB',
        secondary: '#FFC103',
        info: '#41B2FF',
        success: '#51A27E',
        accent: '#F7A941',
        warning: '#FFE081',
        error: '#E30513',

        lightprimary: '#37173C',
        lightsecondary: '#806101',
        lightsuccess: '#29513F',
        lighterror: '#720209',
        lightwarning: '#7D5520',
        lightinfo: '#004D80',

        textPrimary: '#F5F5F5',
        textSecondary: '#FFFFFF',
        borderColor: '#3D3D3D',
        inputBorder: '#515151',
        containerBg: '#1C1C1C',
        background: '#121212',
        hoverColor: '#2A2A2A',
        surface: '#202020',
        'on-surface-variant': '#DCDCDC',

        grey100: '#282828',
        grey200: '#3D3D3D',

        buttonHover: '#37173C',
        buttonHoverText: '#F0E9F1',
        buttonSecondaryHover: '#B896BB',
        buttonSecondaryHoverText: '#282828',

        navActiveText: '#FFFFFF',
        navHoverText: '#D4C0D6',

        surfaceTooltip: '#F5F5F5',
        onSurfaceTooltip: '#282828'
    }
};


export { ULAVAL_DARK_RED_THEME, ULAVAL_DARK_BLUE_THEME, ULAVAL_DARK_PURPLE_THEME };
